// GENERATED CODE 

import { BaseBackend } from "../BaseBackend";
import { MessageList } from "../Types";



export class CForms extends BaseBackend {
	constructor() { super(); this.url='/CApi/Call/CForms'; }
	public ShowXML(formName : string, data : any /* Nwt.Json.JNode */) : Promise<{ Xml: string, Errors: MessageList, XmlIsValid: boolean|null, XmlWarnings: string[] }> { return this.callMethod("ShowXML", arguments); }
	public ValidateOnVVZ(formName : string, data : any /* Nwt.Json.JNode */) : Promise<{ Xml: string, Errors: MessageList, XmlIsValid: boolean|null, XmlWarnings: string[], VVZResponse : any }> { return this.callMethod("ValidateOnVVZ", arguments); }
	public PublicateOnVVZ(formName : string, data : any /* Nwt.Json.JNode */) : Promise<{ Xml: string, Errors: MessageList, XmlIsValid: boolean|null, XmlWarnings: string[], VVZResponse : any }> { return this.callMethod("PublicateOnVVZ", arguments); }
	public PublicateVVZ(token : string, data : any /* Nwt.Json.JNode */) : Promise<any> { return this.callMethod("PublicateVVZ", arguments); }
	public ValidateVVZ(token : string, data : any /* Nwt.Json.JNode */) : Promise<any> { return this.callMethod("ValidateVVZ", arguments); }
	public GetFormContentAndUser(token : string) : Promise<{FormContent:any,Account:any}> { return this.callMethod("GetFormContentAndUser", arguments); }
	public SaveFormContent(token : string, content : any /* Nwt.Json.JNode */) : Promise<'saved'|'nochange'|'failed'> { return this.callMethod("SaveFormContent", arguments); }
	public GetLoginInfo(callbackUid : string) : Promise<LoginInfo> { return this.callMethod("GetLoginInfo", arguments); }
}


